import { render, staticRenderFns } from "./AreasOfConcernAdd.vue?vue&type=template&id=52c45572&"
import script from "./AreasOfConcernAdd.vue?vue&type=script&lang=js&"
export * from "./AreasOfConcernAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports